(function () {
  var STORAGE_KEY = 'ameluna_market';
  var RESET_KEY = 'ameluna_country_reset';

  function getStoredMarket() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveMarket(country, locale) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ country: country, locale: locale }));
  }

  function clearMarket() {
    localStorage.removeItem(STORAGE_KEY);
  }

  function resetShopifyCountry(callback) {
    if (window.Shopify && Shopify.country === 'US') {
      callback();
      return;
    }
    if (sessionStorage.getItem(RESET_KEY) === 'pending') return;

    sessionStorage.setItem(RESET_KEY, 'pending');
    var body =
      'form_type=localization&utf8=' +
      encodeURIComponent('\u2713') +
      '&_method=put&return_to=' +
      encodeURIComponent(window.location.pathname + window.location.search) +
      '&locale_code=en&country_code=US';

    fetch('/localization', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body,
      credentials: 'same-origin',
    }).finally(function () {
      window.location.reload();
    });
  }

  function selectMarket(country, locale) {
    if (country === 'US' && locale === 'en') {
      clearMarket();
      if (window.Shopify && Shopify.country && Shopify.country !== 'US') {
        resetShopifyCountry(function () {});
      } else {
        window.location.reload();
      }
      return;
    }

    saveMarket(country, locale);
    window.location.reload();
  }

  function initMarketForm(form) {
    if (!form || form.dataset.marketFixReady === 'true') return;
    form.dataset.marketFixReady = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    var toggle = form.querySelector('[data-market-toggle]');
    var panel = form.querySelector('[data-market-panel]') || form.querySelector('.localization-market__panel');

    if (toggle && panel) {
      toggle.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var willOpen = panel.hasAttribute('hidden');
          document
            .querySelectorAll('form.localization-form--market [data-market-panel], form.localization-form--market .localization-market__panel')
            .forEach(function (otherPanel) {
              if (otherPanel === panel) return;
              otherPanel.setAttribute('hidden', '');
            });
          document.querySelectorAll('form.localization-form--market [data-market-toggle]').forEach(function (otherToggle) {
            if (otherToggle === toggle) return;
            otherToggle.setAttribute('aria-expanded', 'false');
          });

          if (willOpen) {
            panel.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
          } else {
            panel.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
          }
        },
        true
      );
    }

    form.querySelectorAll('[data-market-select]').forEach(function (button) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          selectMarket(button.dataset.country, button.dataset.locale);
        },
        true
      );
    });
  }

  function initAll() {
    if (sessionStorage.getItem(RESET_KEY) === 'pending') return;

    if (window.Shopify && Shopify.country && Shopify.country !== 'US') {
      resetShopifyCountry(function () {});
      return;
    }

    sessionStorage.removeItem(RESET_KEY);
    document.querySelectorAll('form.localization-form--market').forEach(initMarketForm);
  }

  window.AmelunaMarket = {
    getStoredMarket: getStoredMarket,
    selectMarket: selectMarket,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
